import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { RefreshSessionRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { RefreshSessionResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const refreshSession = (request: RefreshSessionRequest, options?: CashRequestOptions) =>
  post<RefreshSessionRequest, RefreshSessionResponse>('/2.0/cash/refresh-session', request, {
    ...options,
    rejectOnError: true,
  })
